export default __webpack_public_path__ + "static/media/hero-bg-3.97d1cfe0.jpg";